import React, { Component } from 'react';
import { Grid, Row, Col, ButtonToolbar, Button } from 'react-bootstrap';

import { LayoutCanvas } from './LayoutCanvas';
import { LayoutConfigurationProperties } from './LayoutConfigurationProperties';
import { ComponentConfigurationProperties } from './ComponentConfigurationProperties';
import { AvailableComponentsCanvas } from './AvailableComponentCanvas';
import { TitleRow } from '../../TitleRow';

export class LayoutDesign extends Component {
    renderCancelChangesButton(layoutId) {
        if (null === layoutId || undefined === layoutId || "" === layoutId || 0 === layoutId) {
            return null;
        }

        return (
            <Button bsStyle="default"
                onClick={this.props.onCancelChangesLayoutConfiguration} >
                CANCELAR
            </Button>
        );
    }

    renderComponentConfigurationProperties(selectedComponent) {
        if (undefined === selectedComponent.internalId || null === selectedComponent.internalId) {
            return null;
        }

        return (
            <ComponentConfigurationProperties
                component={selectedComponent}
                onDeleteSelectedComponent={this.props.onDeleteSelectedComponent}
                onCancelSelectedComponentProperties={this.props.onCancelSelectedComponentProperties}
                onComponentChangeValue={this.props.onSelectedComponentChangeValue}
                onSaveComponentProperties={this.props.onSaveComponentProperties} />
        );
    }

    render() {
        const { layout, canvas, selectedComponent, componentsStyle, inputNameStyle } = this.props;

        return (
            <div>
                <TitleRow title="Configurar Layout" showSeparator={true}>
                    <ButtonToolbar className="pull-right">
                        <Button onClick={this.props.onSaveLayoutConfiguration}>GUARDAR ALTERAÇÕES</Button>
                        {this.renderCancelChangesButton(layout.id)}
                    </ButtonToolbar>
                </TitleRow>
                <Grid className="margin-top-15" fluid>
                    <Row>
                        <Col sm={12}>
                            <LayoutConfigurationProperties
                                layout={layout}
                                onSaveLayoutProperties={this.props.onSaveLayoutProperties} 
                                inputNameStyle={inputNameStyle} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <LayoutCanvas layout={layout}
                                selectedComponentInternalId={selectedComponent.internalId}
                                selectedGeometryIndex={selectedComponent.selectedGeometryIndex}
                                canvas={canvas}
                                onDragEnter={this.props.onDragEnter}
                                onDragLeave={this.props.onDragLeave}
                                onHitLayout={this.props.onHitLayout}
                                onMoveExistingComponent={this.props.onMoveExistingComponent}
                                onComponentClick={this.props.onComponentClick}
                                onResize={this.props.onResize} />
                        </Col>
                        <Col md={6}>
                            <Grid fluid>
                                <Row>
                                    <Col sm={12}>
                                        <AvailableComponentsCanvas layout={layout}
                                            componentsStyle={componentsStyle} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        {this.renderComponentConfigurationProperties(selectedComponent)}
                                    </Col>
                                </Row>
                            </Grid>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/LayoutDesign.js